var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gif-list"}},_vm._l((_vm.gifs),function(gif){return _c('gif',{key:gif.id,attrs:{"gif":gif}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }